/**
 * @generated SignedSource<<0b2c16e4195d9f1a3731aec6b91ef32c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useRefundRelayByIdQuery$variables = {
  id: string;
};
export type useRefundRelayByIdQuery$data = {
  readonly getRefund: {
    readonly amount: number;
    readonly chargeId: string;
    readonly createdOn: any | null | undefined;
    readonly description: string | null | undefined;
    readonly id: string;
    readonly status: string;
    readonly user: {
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string;
    } | null | undefined;
  } | null | undefined;
};
export type useRefundRelayByIdQuery = {
  response: useRefundRelayByIdQuery$data;
  variables: useRefundRelayByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Refund",
    "kind": "LinkedField",
    "name": "getRefund",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "chargeId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRefundRelayByIdQuery",
    "selections": (v2/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRefundRelayByIdQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "81ee67df3f9bd6c30bf44636aaa75a14",
    "id": null,
    "metadata": {},
    "name": "useRefundRelayByIdQuery",
    "operationKind": "query",
    "text": "query useRefundRelayByIdQuery(\n  $id: ID!\n) {\n  getRefund(id: $id) {\n    id\n    amount\n    createdOn\n    description\n    status\n    chargeId\n    user {\n      id\n      firstName\n      lastName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "94d8b55b900eba00c6679cf4a049def5";

export default node;
